import { faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function testLed() {
    return (
        <div data-cy="historic-testLed">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.testLed" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faLightbulb} size="lg" style={{ color: '#2184da' }} />
            </Whisper>
        </div>
    );
}
